// frontend\src\pages\Calculators\components\Exposure\ShutterSpeedInput.js
import { useState } from 'react';

const ShutterSpeedInput = ({ value, onChange, allowLongExposures }) => {
  const [mode, setMode] = useState(value.includes('/') ? 'fraction' : 'seconds');

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (mode === 'fraction') {
      onChange(inputValue ? `1/${inputValue}` : '');
    } else {
      onChange(inputValue);
    }
  };

  const displayValue = mode === 'fraction' 
    ? value.replace('1/', '') 
    : value;

  return (
    <div className="d-flex flex-column">
      <div className="btn-group btn-group-sm mb-2" role="group">
        <button
          type="button"
          className={`btn ${mode === 'fraction' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setMode('fraction')}
        >
          1/XX
        </button>
        <button
          type="button"
          className={`btn ${mode === 'seconds' ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => setMode('seconds')}
        >
          Секунды
        </button>
      </div>
      <div className="input-group">
        {mode === 'fraction' && (
          <span className="input-group-text">1/</span>
        )}
        <input
          type="number"
          className="form-control"
          value={displayValue}
          onChange={handleInputChange}
          min="0.1"
          step={mode === 'seconds' ? (allowLongExposures ? '1' : '0.1') : '1'}
          placeholder={mode === 'fraction' ? '125' : allowLongExposures ? '30' : '0.5'}
        />
        {mode === 'seconds' && (
          <span className="input-group-text">сек</span>
        )}
      </div>
    </div>
  );
};

export default ShutterSpeedInput;